import { useEffect, useState } from "react";
import { Wrench, X } from "lucide-react";

// ─────────────────────────────────────────────────────────────────────────────
// ROADRIG DEVELOPMENT UPDATE NOTICE
// • Visible from 14 July 2026 through 3 August 2026 inclusive (21 full days),
//   Australia/Sydney timezone. Hides automatically from 4 August 2026 00:00 AEST.
// • Dismissal is per-session only (sessionStorage) — the banner returns on the
//   next visit, so a single accidental ✕ can never hide it permanently.
// • TO REMOVE EARLY: set ENABLED = false below.
// ─────────────────────────────────────────────────────────────────────────────
const ENABLED = true;
const SHOW_FROM = "2026-07-14"; // first day visible (Sydney)
const SHOW_UNTIL = "2026-08-03"; // last day visible, inclusive (Sydney)

const STORAGE_KEY = "roadrig.devnotice.v2.dismissed";

const isLive = () => {
  const sydneyToday = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Australia/Sydney",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
  return sydneyToday >= SHOW_FROM && sydneyToday <= SHOW_UNTIL;
};

export const SurgeryNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ENABLED || !isLive()) return;
    if (sessionStorage.getItem(STORAGE_KEY) === "1") return;
    setVisible(true);
  }, []);

  if (!visible) return null;

  const close = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  return (
    <div
      data-testid="surgery-notice-banner"
      role="status"
      className="relative z-[70] w-full bg-[#141417] border-b border-[#F47A20]/40"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#F47A20] to-transparent" />
      <div className="max-w-7xl mx-auto px-4 md:px-12 py-3 flex items-center gap-3">
        <span className="flex-shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-sm bg-[#F47A20]/15 border border-[#F47A20]/40">
          <Wrench size={14} className="text-[#F47A20]" />
        </span>

        <p data-testid="surgery-notice-text" className="flex-1 text-[11px] md:text-[12px] text-white/80 leading-snug">
          <span className="serial text-[#F47A20] font-bold tracking-[0.2em] uppercase mr-2">🚧 ROADRIG Development Update</span>
          <span className="hidden md:inline">
            John is currently working closely with our manufacturing partners to bring the first ROADRIG prototype to life. Replies may take a little longer than usual, but we&rsquo;re still here and will get back to you as soon as possible. Thanks for being part of the journey.
          </span>
          <span className="md:hidden">
            John is working closely with our manufacturing partners on the first ROADRIG prototype. Replies may take a little longer than usual. Thanks for being part of the journey.
          </span>
        </p>

        <button
          data-testid="surgery-notice-dismiss"
          onClick={close}
          aria-label="Dismiss development update"
          className="flex-shrink-0 text-white/40 hover:text-white transition-colors p-1"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default SurgeryNotice;
